import { Controller } from "@hotwired/stimulus";
import consumer from "../channels/consumer";

export default class extends Controller {
  static targets = ["badge"];
  static values = {
    userId: Number,
    unreadCount: { type: Number, default: 0 }
  };

  connect() {
    if (this.userIdValue) {
      this.subscribeToNotifications();
    }
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  subscribeToNotifications() {
    const controller = this;

    this.subscription = consumer.subscriptions.create(
      {
        channel: "Turbo::StreamsChannel",
        signed_stream_name: this.getSignedStreamName()
      },
      {
        received(_data) {
          // When a new notification comes in, increment the badge count
          controller.incrementBadge();
        }
      }
    );
  }

  getSignedStreamName() {
    // Get the signed stream name from the turbo_stream_from subscription
    // This is already set up in the dashboard layout
    const streamElement = document.querySelector(
      `turbo-cable-stream-source[channel="Turbo::StreamsChannel"]`
    );
    if (streamElement) {
      return streamElement.getAttribute("signed-stream-name");
    }
    return null;
  }

  incrementBadge() {
    this.unreadCountValue += 1;
    this.updateBadgeDisplay();
  }

  updateBadgeDisplay() {
    if (this.hasBadgeTarget) {
      const count = this.unreadCountValue;
      if (count > 0) {
        this.badgeTarget.textContent = count > 99 ? "99+" : count;
        this.badgeTarget.classList.remove("hidden");
      } else {
        this.badgeTarget.classList.add("hidden");
      }
    }
  }
}
